<template>
  <div class="home-page">
    <HeroSection />
    <CompanyIntro />
	<ContactInfo />
    <ServiceCards />
    
  </div>
</template>

<script setup>
// 导入滚动动画composable
import { useScrollAnimation } from '../composables/useScrollAnimation'
useScrollAnimation()

import HeroSection from '../components/HeroSection.vue'
import CompanyIntro from '../components/CompanyIntro.vue'
import ServiceCards from '../components/ServiceCards.vue'
 import ContactInfo from '../components/ContactInfo.vue'
</script>

<style scoped>
.home-page {
  min-height: 100vh;
}
</style>
